module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("PhoneNumbers", "Delete phone number") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc( "PhoneNumbers", "Are you sure you want to delete the following number?" ) ))==null?'':__t)+
'</p><span class="block danger">'+
((__t=( numberName ))==null?'':__t)+
'</span><fieldset class="button-wrap"><button data-click="phone-number-cancel">'+
((__t=( i18n.tc("PhoneNumbers", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="phone-number-submit">'+
((__t=( i18n.tc("PhoneNumbers", "Delete") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
